<template>
  <div class="policy" v-if="routeClass == 2">
    <search-form
      :searcharray="searcharray"
      :span="6"
      @change="search"
      @reset="reset"
    ></search-form>
    <export-excel
      id="policyList"
      name="保单列表"
      size="small"
      text="导出表格"
    ></export-excel>
    <p style="float:right;">{{ totalMoney.total }} 条，总保费：{{ totalMoney.money }} 元。</p>
    <el-table
      :data="tableData"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      style="width: 100%;margin-top:15px"
      row-key="id"
      stripe
      border
      lazy
      size="small"
      class="teamTtable"
      id="policyList"
    >
      <el-table-column prop="num_id" label="流水号" align="center">
      </el-table-column>
      <el-table-column prop="policy_num" label="保单号" align="center">
      </el-table-column>
      <el-table-column
        prop="applicationName"
        label="投保人名称"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="insuredName"
        label="被保人名称"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="productName"
        label="产品名称"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column prop="companyName" label="保险公司" align="center">
      </el-table-column>
      <el-table-column prop="c_time" label="创建时间" align="center">
      </el-table-column>
      <el-table-column prop="s_time" label="生效时间" align="center">
      </el-table-column>
      <el-table-column prop="policy_money" label="保费金额" align="center">
      </el-table-column>
      <el-table-column prop="statusTxt" label="保单状态" align="center">
      </el-table-column>
      <el-table-column prop="work_cate_title" label="职业类别" align="center">
      </el-table-column>
      <el-table-column prop="adminName" align="center" label="提交人">
      </el-table-column>
      <el-table-column prop="checkName" align="center" label="审核人">
    </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="mini"
            @click="look(scope.row.num_id, scope.row.productCate)"
          >
            查看
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="sizeChange"
      @current-change="currentChange"
      :page-sizes="pageSizeArray"
      :page-size.sync="pageSize"
      :current-page.sync="page"
      :total="total"
      background
      layout="total, sizes, prev, pager, next, jumper"
    >
    </el-pagination>
  </div>
  <router-view v-else />
</template>
<script>
import searchForm from "@/components/common/searchForm";
import { getOrderList,getOrderMoney } from "@/api/audit";
import { getCompany } from "@/api/public";
import { getAdmin } from "@/api/system";
import exportExcel from "@/components/common/exportExcel";
export default {
  name: "guarantee",
  data() {
    return {
      routeClass: "",
      searcharray: [
        {
          label: "保险公司",
          val: "company_id",
          type: "select",
          pla: "请选择保险公司",
          option: []
        },
        {
          label: "投保人名称",
          val: "applicationName",
          type: "input",
          pla: "请输入投保人名称"
        },
        {
          label: "被保人名称",
          val: "insuredName",
          type: "input",
          pla: "请输入被保人名称"
        },
        {
          label: "流水号",
          val: "numId",
          type: "input",
          pla: "请输入流水号"
        },
        {
          label: "保单号",
          val: "policyNum",
          type: "input",
          pla: "请输入保单号"
        },
        {
          label: "状态",
          val: "status",
          type: "select",
          pla: "请选择保单状态",
          option: [
            { label: "全部", val: "" },
            { label: "待支付", val: "1" },
            { label: "待审核", val: "2" },
            // { label: "审核成功", val: "3" },
            { label: "驳回", val: "4" },
            { label: "待生效", val: "5" },
            { label: "保障中", val: "6" },
            { label: "已过期", val: "7" },
            { label: "已取消", val: "8" },
            // { label: "申请退款", val: "9" },
            // { label: "已退款", val: "10" },
            { label: "待传资料", val: "11" },
            { label: "保前审核", val: "13" }
          ]
        },
        {
          label: "起保日期",
          val: "sTimeArr",
          type: "date",
          pla: "请选择起保日期"
        },
        {
          label: "创建时间",
          val: "cTimeArr",
          type: "date"
        },
        {
          label: "提交人",
          val: "adminId",
          type: "select",
          pla: "请选择",
          option: []
        },
        {
          label: "审核人",
          val: "checkId",
          type: "select",
          pla: "请选择",
          option: []
        },
        {
          label: "产品名称",
          val: "productName",
          type: "input",
          pla: "请输入流水号"
        }
      ],
      searchData: {},
      loading: false,
      tableData: [],
      // 分页 每页条数
      pageSize: 15,
      // 分页 每页条数可选项
      pageSizeArray: [15, 30, 45, 60, 100000],
      // 当前页
      page: 1,
      // 总页数
      total: 0,
      totalMoney:{},
    };
  },
  components: {
    searchForm,
    exportExcel
  },
  mounted() {
    // 获取当前路由等级
    this.routeClass = this.$route.matched.length;
    // 获取保司
    this.getCompany();
    // 获取列表
    this.getOrderList();
    this.getOrderMoney();
    // 获取当前账号下可用管理员
    this.getAdmin();
  },
  methods: {
    // 搜索数据
    search(e) {
      this.page = 1;
      this.searchData = e;
      this.getOrderList();
      this.getOrderMoney();
    },
    //搜索重置
    reset(e) {
      this.page = 1;
      this.searchData = {};
      this.getOrderList();
      this.getOrderMoney();
    },
    // 获取列表
    getOrderList() {
      let _data = this.searchData;
      let that = this;
      _data.page = this.page;
      _data.limit = this.pageSize;
      _data.identification = 3;
      that.loading = true;
      getOrderList(_data)
        .then(function(res) {
          console.log(res);
          that.loading = false;
          if (res.code == 1) {
            that.tableData = res.data.list;
            that.total = res.data.total;
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getOrderMoney(){
        let _data = this.searchData;
      let that = this;
      _data.page = this.page;
      _data.limit = this.pageSize;
      _data.identification = 3;
      that.loading = true;
      getOrderMoney(_data)
        .then(function(res) {
          console.log(res);
          if (res.code == 1) {
            that.totalMoney = res.data
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    // 每页几条
    sizeChange() {
      this.getOrderList();
    },
    // 页码变化
    currentChange() {
      this.getOrderList();
    },
    look(e, type) {
      // 审核1 查看2 上传资料3
      this.$router.push({
        path: "/dataStatistics/policy/details",
        query: { numId: e, type: type }
      });
    },
    // 获取保司列表
    getCompany() {
      let that = this;
      getCompany()
        .then(function(res) {
          console.log(res);
          if (res.code == 1) {
            that.searcharray[0].option.push({ label: "全部", val: "" });
            res.data.forEach((item, index) => {
              let _obj = { label: "", val: "" };
              _obj.label = item.name;
              _obj.val = item.id;
              that.searcharray[0].option.push(_obj);
            });
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    // 获取当前账号下可用管理员
    getAdmin() {
      let that = this;
      getAdmin()
        .then(function(res) {
          console.log(res);
          if (res.code == 1) {
            res.data.forEach((item, index) => {
              let _obj = { label: "", val: "" };
              _obj.label = item.nickname;
              _obj.val = item.id;
              that.searcharray[8].option.push(_obj);
              that.searcharray[9].option.push(_obj);
            });
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  }
};
</script>
<style lang="scss">
.policy {
  background: #fff;
}
</style>
